import { render, staticRenderFns } from "./OfferPopUp.vue?vue&type=template&id=3b66c4eb"
import script from "./OfferPopUp.vue?vue&type=script&lang=js"
export * from "./OfferPopUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports